import type { TiptapDoc } from '@odo/shared-ui';

/** Matches NoteModal.tsx's own `EMPTY_DOC`: an empty Tiptap document. */
export const EMPTY_CHART_NOTE_DOC: TiptapDoc = { type: 'doc', content: [] };

/** Draft state backing the inline Composer. `id` is set when editing; the
 *  chart note is a real patient note (`TiptapDoc` + title), not plain text. */
export interface AppointmentDraft {
    id?: string;
    patientId: string | null;
    date: string;
    time: string;
    reason: string;
    chartNote: TiptapDoc;
    chartNoteTitle: string;
}

export function emptyDraft(date: string): AppointmentDraft {
    return {
        patientId: null,
        date,
        time: '',
        reason: '',
        chartNote: EMPTY_CHART_NOTE_DOC,
        chartNoteTitle: ''
    };
}
